/**
 * Object.keys in typescript widens the return type to string[]
 * Use this helper function instead to to fix the ts error
 * "No index signature with a parameter of type 'string' was found on type '{}'"
 *
 * @see https://www.totaltypescript.com/tips/create-your-own-objectkeys-function-using-generics-and-the-keyof-operator
 */
export default function objectKeys<T extends object>(obj: T): (keyof T)[] {
  return Object.keys(obj) as (keyof T)[];
}
